// components/About.js
import React from 'react';
import styled from 'styled-components';

const AboutSection = styled.section`
  padding: 4rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
`;

const Card = styled.div`
  background-color: #f5f5f5;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const About = () => {
  return (
    <AboutSection>
      <h2>About Us</h2>
      <p>
        The National Parents Association is dedicated to fostering collaboration
        between parents and educational institutions to ensure the best possible
        learning environment for our children.
      </p>
      
      <Grid>
        <Card>
          <h3>Our Mission</h3>
          <p>
            To empower parents to be effective advocates for their children's
            education and well-being.
          </p>
        </Card>

        <Card>
          <h3>Our Vision</h3>
          <p>
            To create a strong partnership between parents and schools that
            enhances the educational experience of every child.
          </p>
        </Card>

        <Card>
          <h3>Our Values</h3>
          <p>
            Integrity, Collaboration, Excellence, Innovation, and Inclusivity.
          </p>
        </Card>
      </Grid>
    </AboutSection>
  );
};

export default About;